// HORUS version constant.
//
// Konvensi: +0.1 per Sprint sign-off (Sprint 005 → V2.2, Sprint 007 → V2.3).
// Sprint 007 (9-18 Mei 2026) — Sprint 007 engineering work substansial
// sudah landed across all 9 acceptance items + B-002 photo embed live tested.
// Per CSOO directive 2026-05-09: bump full V2.3, accept risk Satria push back
// kalau V-FIN <80/100 (revert plan: rollback ke V2.2 atau bump V2.4).
//
// History:
//   V2.0 base (Tahap 0)
//   V2.1 Sprint 003 sign-off
//   V2.2 Sprint 005 sign-off
//   V2.3-rc1 Sprint 007 engineering complete (interim, dropped 2026-05-09 16:30)
//   V2.3 Sprint 007 (current) — formal V-FIN ≥80/100 target 18 Mei 2026
export const HORUS_VERSION = 'V2.3';
